HTMLElement.prototype.prepareTransition = function(callback) {
  this.addEventListener('transitionend', function() {
    this.classList.remove('is-transitioning');
    if (typeof callback === 'function') callback();    
  }, { once: true });

  let duration = 0 || parseFloat(getComputedStyle(this).transitionDuration);

  if (duration != 0) {
    this.classList.add('is-transitioning');
    this.offsetWidth;
  }

  return this;
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

document.querySelectorAll('header-menu [id^="Details-HeaderMenu"] > summary').forEach((summary) => {
  summary.addEventListener('mouseenter', (e) => {
    if (!summary.parentNode.hasAttribute('open'))
      summary.click();
  });

  summary.parentElement.addEventListener('mouseleave', (e) => {
    if (summary.parentNode.hasAttribute('open'))
      summary.click();
  });
  
});

// document.querySelectorAll('img').forEach((img) => {
//   img.setAttribute('loading', 'eager');
// });

document.querySelectorAll('a[href*=trigger]').forEach((link) => {
  link.addEventListener('click', (e) => {
    e.preventDefault();
    const target = e.currentTarget;
    const modal = document.getElementById(target.getAttribute('href').split('trigger=')[1]);

    if (modal) modal.show(target);
  });
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;
    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
  document.querySelectorAll('.plyr:not(.plyr--html5)').forEach((plyrElement) => {
    if (plyrElement.classList.contains('plyr--paused')) return;
    plyrElement.querySelector('button[data-plyr="play"]').click();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function plyrCustomEvents() {
  this.addEvents = this.addEvents;
  this.removeEvents = this.removeEvents;
}

plyrCustomEvents.prototype = Object.assign(plyrCustomEvents.prototype, {
  addEvents(player) {
    player.on('ready', this.onReady);
    player.on('play', this.onPlay);
    player.on('volumechange', this.onVolumeChange);

    if (player.isVimeo) {
      player.on('captionsenabled', this.onCaptionsEnabled);
      player.on('languagechange', this.onLanguageChange);    
      player.on('captionsdisabled', this.onCaptionsDisabled);
    }
    
  },

  removeEvents(player) {
    player.off('ready', this.onReady);
    player.off('play', this.onPlay);
    player.off('volumechange', this.onVolumeChange);

    if (player.isVimeo) {
      player.off('captionsenabled', this.onCaptionsEnabled);
      player.off('languagechange', this.onLanguageChange);    
      player.off('captionsdisabled', this.onCaptionsDisabled);
    }
    
  },

  onReady: (e) => {
    const player = e.detail.plyr;
    player.volume = 1;

    if (player.autoplay) {    
      player.muted = true;
      player.embed.setAutopause(false);
      player.play();
    } else {
      player.muted = false;
    }
  },

  onPlay: (e) => {
    const player = e.detail.plyr;
    if (player.muted) return;
    
    player.muted = true;
    setTimeout(() => {
      player.muted = false;
    }, 100);
  },
  
  onVolumeChange: (e) => {
    const player = e.detail.plyr;
    
    if (!player.muted) {
      player.elements.buttons.mute?.classList.remove('plyr__control--pressed');
    } else {
      player.elements.buttons.mute?.classList.add('plyr__control--pressed');
    }
  },

  onCaptionsEnabled: (e) => {
    const player = e.detail.plyr;
    const language = player.language;

    player.embed.enableTextTrack(language);
  },

  onLanguageChange: (e) => {
    const player = e.detail.plyr;
    const language = player.language;

    if (!language) return;
    
    player.embed.disableTextTrack();
    player.embed.enableTextTrack(language);
  },

  onCaptionsDisabled: (e) => {
    const player = e.detail.plyr;
    
    player.embed.disableTextTrack();
  }

});

window.plyrCustomEvents = new plyrCustomEvents();

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    if (this.input.hasAttribute('disabled')) return;
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
    this.dispatchEvent(new CustomEvent('show'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
    this.dispatchEvent(new CustomEvent('hide')); 
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);

      if (content.querySelector('model-viewer')) {
        const deferredElement = this.appendChild(content.querySelector('model-viewer'));
        if (focus) deferredElement.focus();
      } else {
        const isNativeVideo = !!content.querySelector('video');
        const deferredElement = this.appendChild(isNativeVideo ? content.querySelector('video') : content);
        if (focus) deferredElement.focus();
        const player = new Plyr(deferredElement, {
          autoplay: true,
          fullscreen: {
            enabled: true,
            fallback: true, 
            iosNative: true, 
            container: null
          },
          loop: {
            active: true  
          },
          muted: true
        });
        if (isNativeVideo) deferredElement.play();
        plyrCustomEvents.addEvents(player);
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    this.mouse = {
      startX: 0,
      startPoint: 0,
      dist: 0
    };
    this.isDragging = false;

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    this.resizeObserver = new ResizeObserver((entries) => this.initPages());
    this.resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    this.slider.addEventListener('mousedown', this.onMousedown.bind(this));
    this.slider.addEventListener('mousemove', this.onMousemove.bind(this));
    this.slider.addEventListener('mouseup', this.onMouseup.bind(this));
  }

  disconnectedCallback() {
    // this.resizeObserver.unobserve(this.slider);
    // this.resizeObserver.disconnect();
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  onMousedown(e) {
    // this.slider.classList.add('slider--is-dragging');
    this.isDragging = true;
    this.mouse.startX = e.pageX;
    this.mouse.startPoint = this.slider.scrollLeft;

  }

  onMousemove(e) {
    if (!this.isDragging) return;
    this.mouse.dist = e.pageX - this.mouse.startX;
    // this.slider.scrollLeft = Math.round(this.mouse.startPoint - this.mouse.dist);

    // this.mouse.startPoint - this.mouse.dist > 0 ? this.nextButton.dispatchEvent(new Event('click')) : this.prevButton.dispatchEvent(new Event('click'))
    
  }

  onMouseup() {
    this.isDragging = false;

    this.mouse.dist < 0 ? this.nextButton.dispatchEvent(new Event('click')) : this.prevButton.dispatchEvent(new Event('click'));
    // this.nextButton.dispatchEvent(new Event('click'));
    // this.slider.style.setProperty('scroll-behavior', 'smooth')
    // this.slider.style.setProperty('scroll-snap-type', 'x mandatory')
    // this.slider.classList.remove('slider--is-dragging');
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();

    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;
    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class ProductCardMediaSlider extends SliderComponent {
  constructor() {
    super();

    this.sliderControlWrapper = this.querySelector('[data-card-slider-navigation]');
    this.enableSliderLooping = false;

    if (!this.sliderControlWrapper) return;
    this.sliderFirstItemNode = this.slider.querySelector('[data-card-slider-slide]');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('[data-card-slider-dot]'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    this.sliderControlButtons = this.querySelectorAll('[data-card-slider-dot]');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('card__media-slider__dot--active');
      link.removeAttribute('aria-current');
    });

    this.sliderControlButtons[this.currentPage - 1].classList.add('card__media-slider__dot--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);

    if (this.enableSliderLooping) return;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (isFirstSlide) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (isLastSlide) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
    
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('product-card-media-slider', ProductCardMediaSlider);

class ProductSection extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      content: '[data-content]'
    };

    this.classes = {
      active: 'active'
    };

    this.data = {
      productHandle: 'productHandle'
    };

    this.attr = {
      productHandle: 'data-product-handle'  
    };
    
  }

  productChangeUnsubscriber = undefined;
  
  connectedCallback() {
    this.productChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.productChange, (event) => {
      const productHandle = event.data.productHandle;
      this.changeContent(productHandle);
    });
  }

  changeContent(productHandle) {
    const currentContent = this.querySelector(`${this.selectors.content}.${this.classes.active}`);
    const newContent = this.querySelector(`${this.selectors.content}[${this.attr.productHandle}="${productHandle}"]`);
    if (currentContent) currentContent.classList.remove(this.classes.active);
    if (newContent) newContent.classList.add(this.classes.active);
  }
 
}

customElements.define('product-section', ProductSection);

class MultipleSwatches extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      swatch: '[data-swatch]'  
    }

    this.classes = {
      loading: 'loading'
    }

    this.data = {
      productHandle: 'productHandle',
      section: 'section',
      url: 'url'
    }

    this.select = this.querySelector('select-component');
    
    this.select?.addEventListener('change', this.onSwatchChange.bind(this));
    this.querySelectorAll(this.selectors.swatch)?.forEach((s) => { s.addEventListener('click', this.onSwatchClick.bind(this)) });
    
    this.loadingContent = false;
  }

  onSwatchChange(e) {
    const value = e.detail.value;
    const option = this.select.querySelector(`[data-value="${value}"]`);
    const url = option.dataset[this.data.url];
    const productHandle = option.dataset[this.data.productHandle];

    this.changeProductPage(url, productHandle);
    
  }

  onSwatchClick(e) {
    e.preventDefault();
    const swatch = e.currentTarget;
    const url = swatch.dataset[this.data.url];
    const productHandle = swatch.dataset[this.data.productHandle];
      
    this.changeProductPage(url, productHandle);
    
  }

  changeProductPage(url, productHandle) {
    if (
      window.location.pathname == url ||
      this.loadingContent
    ) return;

    document.getElementById(`MainProduct-${this.dataset[this.data.section]}`)
      .classList.add(this.classes.loading);

    const fetchUrl = `${url}?section_id=${this.dataset[this.data.section]}`;
    const filterCacheUrl = (cache) => cache.url === url;

    MultipleSwatches.cache.some(filterCacheUrl) ?
      this.renderProductPageFromCache(filterCacheUrl, url, productHandle) :
      this.renderProductPageFromFetch(fetchUrl, url, productHandle);
  }

  renderProductPageFromCache(filterCacheUrl, url, productHandle) {
    const html = MultipleSwatches.cache.find(filterCacheUrl).html;

    this.replaceProductPage(html);
    this.updateUrl(url);

    publish(PUB_SUB_EVENTS.productChange, {
      data: {
        productHandle: productHandle
      }
    });

    this.loadingContent = false;
    
  }

  renderProductPageFromFetch(fetchUrl, url, productHandle) {
    this.loadingContent = true;
    fetch(fetchUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        MultipleSwatches.cache = [...MultipleSwatches.cache, { html, url }];
        
        this.replaceProductPage(html);
        this.updateUrl(url);

        publish(PUB_SUB_EVENTS.productChange, {
          data: {
            productHandle: productHandle
          }
        });
        
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.loadingContent = false;
      });
  }

  replaceProductPage(html) {
    const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
    const currentProductPage = document.getElementById(`MainProduct-${this.dataset[this.data.section]}`);
    const currentProductPageParent = currentProductPage.parentNode;
    const newProductPage = parsedHtml.getElementById(`MainProduct-${this.dataset[this.data.section]}`);

    currentProductPage.remove();
    currentProductPageParent.append(newProductPage);

  }

  updateUrl(url) {
    window.history.replaceState({}, '', url);
  }
  
}

MultipleSwatches.cache = [];

customElements.define('multiple-swatches', MultipleSwatches);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.updateOptions();
    this.updateMasterId();
    this.addEventListener('change', this.onVariantChange);

    const productHandle = (this.dataset.url || '').split('/products/')[1]?.split(/[?#]/)[0];
    if (this.dataset.early === 'true' && productHandle) {
      const earlyHandles = JSON.parse(sessionStorage.getItem('earlyAccessHandles') || '[]');
      if (!earlyHandles.includes(productHandle)) {
        earlyHandles.push(productHandle);
        sessionStorage.setItem('earlyAccessHandles', JSON.stringify(earlyHandles));
      }
    } else if (productHandle) {
      const earlyHandles = JSON.parse(sessionStorage.getItem('earlyAccessHandles') || '[]');
      if (earlyHandles.includes(productHandle)) {
        this._earlyFromSession = true;
        this.renderProductInfo();
      }
    }
  }

  onVariantChange(e) {
    const selectedElement = e.target.tagName === 'INPUT' ? e.target : e.target.options[e.target.selectedIndex];
    this.toggleAddButton(true, '', false);
    
    if (selectedElement.matches('[data-pp-bundle-trigger]')) {
      this.setupProductPageBundle(selectedElement);
      this.hideProductSticky();
    } else {
      this.hideProductPageBundle();
      this.showProductSticky();
      this.updateOptions();
      this.updateMasterId();
      this.toggleSampleButton();
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantStatuses();
  
      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();
      }
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  getCurrentVariant() {
    return this.currentVariant;
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    this.switchMedia(this.currentVariant.featured_media.id);
  }

  switchMedia(mediaId) {
    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${mediaId}`, false)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${mediaId}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const productForm = document.querySelector(`product-form[data-section-id="${this.dataset.section}"]`);
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    const isEarly = this.dataset.early === 'true' || this._earlyFromSession;
    const earlyParam = isEarly ? '&early=true' : '';
    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }${earlyParam}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');        
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const stickyPriceDestination = document.getElementById(`sticky-price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const bisButtonDestination = document.getElementById(`BisPopup-${this.dataset.section}`);
        const bisButtonSource = html.getElementById(
          `BisPopup-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (source && stickyPriceDestination) stickyPriceDestination.innerHTML = source.innerHTML;
        
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        if (bisButtonSource && bisButtonDestination) {
          bisButtonDestination.innerHTML = bisButtonSource.innerHTML;
          bisButtonDestination.classList.toggle('hidden', bisButtonSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');
        if (stickyPriceDestination) stickyPriceDestination.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );
        const stickyAddButton = document.getElementById(`ProductStickySubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut,
          true,
          stickyAddButton
        );
        

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true, button) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = button || productForm.querySelector('[name="add"]');
    const addButtonText = addButton.querySelector('span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  toggleSampleButton() {
    const section = document.getElementById(`MainProduct-${this.dataset.section}`);
    const buttons = section.querySelectorAll('[data-bundle-button][data-button-show-for]');

    buttons.forEach(button => {
      let variants = button.dataset.buttonShowFor.split(',');
      this.currentVariant && variants.includes(this.currentVariant.title) ? button.classList.remove('hidden') : button.classList.add('hidden');
    });
  }
  
  hideProductSticky() {
    document.getElementById(`ProductSticky-${this.dataset.section}`)?.classList.add('hidden');
  }

  showProductSticky() {
    document.getElementById(`ProductSticky-${this.dataset.section}`)?.classList.remove('hidden');
  }
  
  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const bisButton = document.getElementById(`BisPopup-${this.dataset.section}`);
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    if (addButtonText) addButtonText.textContent = window.variantStrings.unavailable;
    if (bisButton) bisButton.classList.add('hidden');
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  hideProductPageBundle() {
    this.closest('product-info').classList.remove('product__pp-bundle--active');
    
  }
  
  setupProductPageBundle(trigger) {
    const mediaId = trigger.dataset.ppBundleMediaId;
    if (mediaId) this.switchMedia(mediaId);
    if (this.closest('product-info').classList.contains('product__pp-bundle--initialized')) {
      this.closest('product-info').classList.add('product__pp-bundle--active');
    } else {
      this.renderProductPageBundle();
    }
  }

  renderProductPageBundle() {
    const isEarlyBundle = this.dataset.early === 'true' || this._earlyFromSession;
    const earlyBundleParam = isEarlyBundle ? '&early=true' : '';
    fetch(`${this.dataset.url}?section_id=product-page-bundle${earlyBundleParam}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const ppBundleContainer = document.getElementById(`ProductPPBundleContainer-${this.dataset.section}`);
        ppBundleContainer.innerHTML = html.querySelector('.shopify-section').innerHTML;
        this.closest('product-info').classList.add('product__pp-bundle--initialized', 'product__pp-bundle--active');
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class Tabs extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      toggler: '[data-tab-toggler]',
      content: '[data-tab-content]'
    }
  
    this.attr = {
      tabsInitialized: 'data-tabs-initialized',
      tabId: 'data-tab-id',
      tabsId: 'data-tabs-id',
      isTransitioning: 'data-is-transitioning'
    }

    this.data = {
      tabContainerId: 'tabContainerId',
      tabsInitialized: 'tabsInitialized',
      tabId: 'tabId',
      tabsId: 'tabsId'
    }
    
    this.classes = {
      active: 'active',
      tabIsTransitioning: 'tab--is-transitioning'
    }

    this.tabTogglers = 
      [...this.querySelectorAll(this.selectors.toggler)]
        .filter(tabToggler => {
          return tabToggler.closest('tabs-component') === this;
        });
    this.tabContents = 
      [...this.querySelectorAll(this.selectors.content)]
        .filter(tabContent => {
          return tabContent.closest('tabs-component') === this;
        });
    
    this.tabsId = this.hasAttribute(this.attr.tabsId) ? this.dataset[this.data.tabsId] : false

    this.openTabFromUrl();
    this.initEvents();
    
  }

  initEvents() {
    this.tabTogglers.forEach((tabToggler) => {
      tabToggler.addEventListener('click', this.changeTab.bind(this));
    });
    
  }

  changeTab(e) {
    e.preventDefault();
    const tabToggler = e.currentTarget;
    const id = tabToggler.dataset[this.data.tabId];
    
    if (
      tabToggler.classList.contains(this.classes.active)
    ) return;

    this.openTab(id);
    
  }

  openTab(tabId, dispatchEvent = true) {
    const tabTogglers = this.querySelectorAll(`${this.selectors.toggler}[${this.attr.tabId}="${tabId}"]`);
    const tabContents = this.querySelectorAll(`${this.selectors.content}[${this.attr.tabId}="${tabId}"]`);

    if (!tabContents) return; 

    [...this.tabTogglers, ...this.tabContents].forEach((tabComp) => { tabComp.classList.remove(this.classes.active) });
    [...tabTogglers, ...tabContents].forEach((tabComp) => { tabComp.classList.add(this.classes.active) });

    if (dispatchEvent) {
      this.dispatchEvent(
        new CustomEvent('tabChange', {
          detail: {
            tabTogglers: tabTogglers,
            tabContents: tabContents
          }
        })
      );
    }
    
    this.setUrl(tabId);
  }

  setUrl(tabId) {
    if (!this.tabsId) return;
    window.history.replaceState({}, '', `${window.location.pathname}?${this.tabsId}=${tabId}`);
    
  }

  openTabFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    
    if (
      !this.tabsId ||
      !urlParams.has(this.tabsId)
    ) return;

    const tabId = urlParams.get(this.tabsId);

    this.openTab(tabId);
    
  }
  
}

customElements.define('tabs-component', Tabs);

class Accordions extends HTMLElement {
  constructor() {
    super();

    this.togglers = [...this.querySelectorAll('summary')];

    this.togglers.forEach((summary) => {
      summary.addEventListener('click', (e) => {
        const summaryElement = e.currentTarget;
        
        this.togglers
          .filter(toggler => toggler !== summaryElement)
          .forEach((toggler) => {
            toggler.parentNode.removeAttribute('open');
            toggler.setAttribute('aria-expanded', 'false');
          });
      });
    });
    
  }
  
}

customElements.define('accordions-component', Accordions);

class Select extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      option: '[data-option]',
      selectText: '[data-select-text]'
    }

    this.data = {
      value: 'value'
    }

    this.attr = {
      selected: 'selected'
    }

    this.summary = this.querySelector('summary');
    this.selectText = this.querySelector(this.selectors.selectText);
    this.options = [...this.querySelectorAll(this.selectors.option)];
    this.summary.addEventListener('click', this.onSelectToggle.bind(this));
    this.addEventListener('click', this.selectOption.bind(this));
    
    //add trap focus and remove trap focus
    //add close with body click
    //use modal dialog for the video modal on mobile
    //what is deferred media 
  }

  onSelectToggle(e) {
    const summary = e.currentTarget;
    setTimeout(() => {
      if (summary.parentNode.hasAttribute('open')) {
        document.body.addEventListener('click', this.onBodyClick);
      } else {
        document.body.removeEventListener('click', this.onBodyClick);
      }
    });
  }

  setValue(value, option) {
    option = option || this.querySelector(`${this.selectors.option}[data-${this.data.value}="${value}"]`);
    if (!option) return;

    const text = option.innerHTML;
    
    this.dataset[this.data.value] = value;
    this.selectText.innerHTML = text;

    this.options.forEach((op) => { op.removeAttribute(this.attr.selected) });
    option.setAttribute(this.attr.selected, this.attr.selected);
  }
  
  selectOption(e) {
    if (e.target && e.target.matches(this.selectors.option)) {
      const option = e.target;
      const value = option.dataset[this.data.value];
  
      if (value === this.dataset[this.data.value]) {
        this.closeSelect();
        return;
      }
      
      this.setValue(value, option);
      
      this.dispatchEvent(
        new CustomEvent('change', {
          detail: {
            value: value,
            option: option
          }
        })
      );

      this.closeSelect();
    }
  }

  onBodyClick = (e) => {
    if (
      this === e.target ||
      this.contains(e.target)
    ) return;

    this.closeSelect();
  }

  closeSelect() {
    this.summary.parentNode.removeAttribute('open');
    this.summary.setAttribute('aria-expandend', 'false');
    document.body.removeEventListener('click', this.onBodyClick);
  }
}

customElements.define('select-component', Select);

(function cartActionFromUrl() {
  const params = new URLSearchParams(window.location.search);
  if (params.get('cart_action') !== 'add') return;

  const id = params.get('id');
  if (!id) return;

  function buildFormHtml() {
    let inputs = `<input type="hidden" name="id" value="${id}">`;
    inputs += `<input type="hidden" name="quantity" value="${params.get('quantity') || '1'}">`;

    params.forEach((value, key) => {
      if (key.match(/^properties\[.+\]$/) || key.startsWith('items[')) {
        inputs += `<input type="hidden" name="${key}" value="${value}">`;
      }
    });

    return `<form method="post" action="/cart/add" style="display:none">${inputs}<button type="submit"></button></form>`;
  }

  function cleanUrl() {
    const url = new URL(window.location);
    url.searchParams.delete('cart_action');
    url.searchParams.delete('id');
    url.searchParams.delete('quantity');
    [...url.searchParams.keys()].forEach(key => {
      if (key.startsWith('properties[') || key.startsWith('items[')) url.searchParams.delete(key);
    });
    window.history.replaceState({}, '', url);
  }

  function submit() {
    const wrapper = document.createElement('div');
    wrapper.style.display = 'none';
    wrapper.innerHTML = `<product-form data-hide-errors="true">${buildFormHtml()}</product-form>`;
    document.body.appendChild(wrapper);

    cleanUrl();
    wrapper.querySelector('button[type="submit"]').click();
  }

  if (customElements.get('product-form')) {
    submit();
  } else {
    const script = document.createElement('script');
    script.src = routes.product_form_url;
    script.onload = () => {
      customElements.whenDefined('product-form').then(submit);
    };
    script.onerror = () => console.error('Failed to load product-form.js');
    document.head.appendChild(script);
  }
})();
